const smartListWithFormStyle = {
    fullHeight: { height: '100%' },
    form: { width: '100%' },
};

export default smartListWithFormStyle;
